import { BreakpointsMinQuery } from '@ab-core/breakpoints';
import { Colors, Shadows } from '@ab-core/colors';
import { RADIUS } from '@ab-core/radius';
import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const SheetContent = styled.div`
    padding: ${SPACING.SMALL_2} 0;
    @media ${BreakpointsMinQuery.lg} {
        padding: ${SPACING.SMALL_5} 0;
    }
`;

export const StyledSheet = styled.section`
    &.ab-sheet-styleType-flat {
        border: 1px solid ${Colors.gray30};
    }
    &.ab-sheet-styleType-card {
        box-shadow: ${Shadows.componentShadow};
    }
    width: 100%;
    position: relative;
    background-color: ${Colors.white};
    padding: ${SPACING.SMALL_4};
    @media ${BreakpointsMinQuery.lg} {
        padding: ${SPACING.MEDIUM};
    }
    border-radius: ${RADIUS.ROUNDED};
    margin: ${SPACING.SMALL_2} 0;
    &.ab-sheet-active {
        border-left: 6px solid ${Colors.primary};
    }
`;
